import { localize } from '../i18n';
import React, { useEffect, useState } from 'react';
import { Box, IconButton, Typography } from '@mui/material';
import { useRegistrationDraft } from './RegistrationDraftProvider';
import CloseIcon from '@mui/icons-material/Close';
import RegistrationDraftChoice from './RegistrationDraftChoice';
import { discardRegistrationDraft, draftSummary } from '../utils/registrationDraft';
import { draftPrimaryButton, draftSecondaryButton, RegistrationDraftButton as Button } from './RegistrationDraftChoice';
import { trackProduct } from '../utils/productAnalytics';

export default function RegistrationDraftCard({ onResume, onNew }) {
    const state = useRegistrationDraft();
    const draft = state?.draft;
    const [discardTarget, setDiscardTarget] = useState(null);
    const [error, setError] = useState('');
    const closeDiscard = () => { setDiscardTarget(null); setError(''); };
    const discard = () => {
        if (discardRegistrationDraft(discardTarget)) closeDiscard();
        else setError(localize("작성 내용이 바뀌었어요. 다시 열어주세요."));
    };
    useEffect(() => {
        if (draft) trackProduct('journey_view', { feature: 'registration_draft', source: draft.source, sessionId: draft.flowId }, `${draft.flowId}_draft_view`);
    }, [draft?.id]); // One exposure per card mount, not per save/foreground.
    if (!draft || !state.ready) return null;
    const pending = draft.status === 'pending';
    return <Box sx={{ bgcolor: '#fff', borderRadius: '16px', border: '1px solid #f0f0f0', p: 2, textAlign: 'left' }}>
        <Box sx={{ display: 'flex', alignItems: 'flex-start', gap: 1 }}>
            <Typography component="h2" sx={{ flex: 1, minWidth: 0, fontWeight: 700, fontSize: 16, letterSpacing: '-0.02em', lineHeight: 1.3, color: '#1a1a1a' }}>
                {pending ? localize("약 등록 결과를 확인해주세요") : localize("작성 중인 약 등록이 있어요")}
            </Typography>
            {!pending && <IconButton aria-label={localize("작성 내용 버리기")} onClick={() => { setError(''); setDiscardTarget(draft); }}
                sx={{ width: 44, height: 44, flexShrink: 0, mt: -1, mr: -1, color: '#666' }}><CloseIcon /></IconButton>}
        </Box>
        <Typography sx={{ color: '#777', fontSize: 13, fontWeight: 500, letterSpacing: '-0.01em', mt: 0.75, mb: 2, lineHeight: 1.45 }}>{draftSummary(draft)}</Typography>
        <Box sx={{ display: 'grid', gap: 1 }}>
            <Button fullWidth variant="contained" sx={draftPrimaryButton} onClick={onResume}>{pending ? localize("등록 결과 확인하기") : localize("이어서 등록하기")}</Button>
            {!pending && <Button fullWidth variant="contained" sx={draftSecondaryButton} onClick={onNew}>{localize("새로 등록하기")}</Button>}
        </Box>
        {discardTarget && <RegistrationDraftChoice open discarding draft={discardTarget} onClose={closeDiscard} onDiscard={discard} error={error} />}
    </Box>;
}
